import { render, staticRenderFns } from "./PurchaseSummaryByCourseReportPage.vue?vue&type=template&id=f2c8272e&scoped=true"
import script from "./PurchaseSummaryByCourseReportPage.vue?vue&type=script&lang=js"
export * from "./PurchaseSummaryByCourseReportPage.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSummaryByCourseReportPage.vue?vue&type=style&index=0&id=f2c8272e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c8272e",
  null
  
)

export default component.exports